import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getOtpRoute } from 'src/utils/adminOtp';
import useAuth from '../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const {
    isAuthenticated, isInitialised, otpPending, otpPhase
  } = useAuth();
  if (isInitialised && !isAuthenticated) {
    if (otpPending) {
      return <Redirect to={getOtpRoute(otpPhase)} />;
    }
    return <Redirect to="/auth/login" />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
